var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1.63636C5.71134 1.63636 4.66667 2.7353 4.66667 4.09091C4.66667 5.44652 5.71134 6.54545 7 6.54545C8.28866 6.54545 9.33333 5.44652 9.33333 4.09091C9.33333 2.7353 8.28866 1.63636 7 1.63636ZM3.11111 4.09091C3.11111 1.83156 4.85223 0 7 0C9.14777 0 10.8889 1.83156 10.8889 4.09091C10.8889 6.35026 9.14777 8.18182 7 8.18182C4.85223 8.18182 3.11111 6.35026 3.11111 4.09091ZM7 11.0909C4.81982 11.0909 2.82628 12.0889 1.34369 13.7431C1.04901 14.0719 0.556766 14.0871 0.244222 13.7771C-0.0683214 13.4671 -0.0828061 12.9493 0.21187 12.6205C1.95901 10.6712 4.35037 9.45454 7 9.45454C9.64962 9.45454 12.041 10.6712 13.7881 12.6205C14.0828 12.9493 14.0683 13.4671 13.7558 13.7771C13.4432 14.0871 12.951 14.0719 12.6563 13.7431C11.1737 12.0889 9.18018 11.0909 7 11.0909Z",
    fill: "#1B284B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIcon);
export default __webpack_public_path__ + "static/media/LoginIcon.ac1829b1db2afcb37b9fd7bb972f3b55.svg";
export { ForwardRef as ReactComponent };